module.exports = __webpack_public_path__ + "img/touch-express-logo.f7bb455e.svg";